module.exports = __webpack_public_path__ + "static/homepage-2-1ab070ccfeeccbd0934f29b72c244a54.png";